var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "newDailog"
    }
  }, [_c('el-dialog', {
    staticClass: "t_left",
    attrs: {
      "title": _vm.title,
      "visible": _vm.info.show,
      "width": "442px",
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.info, "show", $event);
      },
      "close": _vm.changeVal
    }
  }, [_vm._t("default"), _c('div', {
    staticClass: "diaContent t_right"
  }, [_vm.showCaneclBtn ? _c('el-button', {
    on: {
      "click": _vm.changeVal
    }
  }, [_vm._v(_vm._s(_vm.$t('galleryHost.cancel')))]) : _vm._e(), _vm.showConfirmBtn ? _c('el-button', {
    staticClass: "joinBtn",
    on: {
      "click": _vm.event
    }
  }, [_vm._v(_vm._s(_vm.$t('galleryHost.ok')))]) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };